export default __webpack_public_path__ + "static/media/helpAddCoustom.0587979b.png";